import { Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonType, LvrButton } from '../lvr-button/lvr-button';

@Component({
	selector: 'lvr-default-actions',
	template: `
		<div class="actions-row">
			<ng-content></ng-content>
			@if (!hideCancelSave()) {
				<lvr-button
					variant="secondary"
					[label]="labelCancel() | transloco"
					[type]="'button'"
					[disabled]="disableCancelSave()"
					(clicked)="cancelSave.emit()"
					icon="disabled_by_default"
				>
				</lvr-button>
			}
			@if (!hideSave()) {
				<lvr-button
					variant="primary"
					[label]="labelSave() | transloco"
					[type]="saveButtonType()"
					[disabled]="disableSave()"
					(clicked)="save.emit()"
					[loading]="showLoading()"
					icon="save"
				>
				</lvr-button>
			}
		</div>
	`,
	imports: [TranslocoPipe, LvrButton],
})
export class LvrDefaultActions {
	public readonly disableSave = input<boolean>(false);
	public readonly disableCancelSave = input<boolean>(false);

	public readonly labelSave = input<string>('base.button.save');
	public readonly labelCancel = input<string>('base.button.cancel');

	public readonly hideSave = input<boolean>(false);
	public readonly hideCancelSave = input<boolean>(false);

	public readonly saveButtonType = input<ButtonType>('submit');

	public readonly showLoading = input<boolean>(false);

	public readonly save = output<void>();
	public readonly cancelSave = output<void>();
}
